<template>

  <div class="lobby-home-theme clearfix">

    <div class="lobby-heading-body">

      <div class="visible-pc">

        <div class="pc-heading">

          <!-- Swiper -->
          <div class="swiper-container home-swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="index in list">

                <div class="lobby-theme-home-header-bg" :class="'item'+index">
                  <div class="container">

                    <div class="row">
                      <div class="col-md-12">
                        <div class="layer">
                          <img src="../../../common/assets/img/course/newlayer.png"
                               @click.stop.prevent="topic.click()"/>
                          <div class="description">
                            最后更新：{{ currentTime }} 参与学生：59 学科门类：设计学 课程标签：通识核心课 访问量：{{ visit }}
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>

              </div>

            </div>
            <!-- Add Arrows -->
            <div class="swiper-button-next home-swiper-button-next"></div>
            <div class="swiper-button-prev home-swiper-button-prev"></div>
          </div>


          <div class="lobby-theme-home-menu-bar">
            <div class="container">

              <MenuBarView :menus="topic.menus"/>

            </div>
          </div>

        </div>
      </div>

      <div class="visible-mobile">

        <div class="mobile-heading">

          <div>
            <img class="poster" @click.stop.prevent="$router.push('/'+topic.location)"
                 src="../../../common/assets/img/logo.png"/>
          </div>


          <a class="btn btn-primary btn-circle menu-trigger" href="javascript:void(0)" @click="showMenu=!showMenu">
            <i v-show="!showMenu" class="fa fa-list"></i>
            <i v-show="showMenu" class="fa fa-times"></i>
          </a>

          <MenuListView :menus="topic.menus" v-model="showMenu"/>

        </div>
      </div>

      <div>
        <router-view></router-view>
      </div>
    </div>

    <FooterView/>

  </div>


</template>

<script>

import MenuBarView from "./widget/MenuBarView.vue";
import MenuListView from "./widget/MenuListView.vue";
import FooterView from "./widget/FooterView.vue";

import Swiper from "swiper";
import {getDaysBetweenNow, simpleDate} from "../../../common/filter/time";
import {randomNum} from "../../../common/filter/str";

export default {
  data() {
    return {
      list: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      user: this.$store.state.user,
      showMenu: false,
      currentTime: simpleDate(new Date()),
      visit: 57888 + getDaysBetweenNow("2018-12-01") * 10 + (new Date().getDate()) % 9,
      swiper: null
    }
  },
  computed: {
    topic() {
      return this.$route.meta.topic;
    }
  },
  components: {
    MenuBarView,
    MenuListView,
    FooterView
  },
  watch: {},
  methods: {

    refresh() {
    }
  },
  created() {

  },
  mounted() {
    setTimeout(function () {
      this.swiper = new Swiper('.home-swiper-container', {
        autoplay: 6000,
        speed: 1000,
        // Optional parameters
        direction: 'horizontal',
        loop: true,

        // Navigation arrows
        nextButton: '.home-swiper-button-next',
        prevButton: '.home-swiper-button-prev'
      });
    }, 300);

  }
}

</script>


<style lang="less" rel="stylesheet/less">

@import "../../../common/assets/css/global/variables";

//菜单样式
.lobby-home-theme {

  height: 100%;
  position: relative;
  padding-bottom: 60px;

  .swiper-container {
    width: 100%;
  }

  .lobby-heading-body {
    min-height: 100%;

    .pc-heading {
      background-color: @main-color;

      .poster {
        cursor: pointer;
        max-width: 100%;
      }

      .search-box {

        color: white;

        .form-control {
          background: transparent;
        }

        .btn-default {
          background: transparent;
        }
      }

    }

    .mobile-heading {
      position: relative;
      background-color: @main-color;

      .poster {
        cursor: pointer;
        max-height: 60px;
      }

      .menu-trigger {
        position: absolute;
        right: 15px;
        top: 15px;
      }
    }

  }

  //没有海报时候的样式.
  .poster-title {
    color: white;
    font-size: 30px;
    padding: 20px 10px;
    cursor: pointer;
  }

  .lobby-theme-home-header-bg {
    height: 448px;

    background-image: url("../../../common/assets/img/course/bg0.png");

    &.item0 {
      background-image: url("../../../common/assets/img/course/bg0.png");
    }

    &.item1 {
      background-image: url("../../../common/assets/img/course/bg1.jpg");
    }

    &.item2 {
      background-image: url("../../../common/assets/img/course/bg2.png");
    }

    &.item3 {
      background-image: url("../../../common/assets/img/course/bg3.jpg");
    }

    &.item4 {
      background-image: url("../../../common/assets/img/course/bg4.png");
    }

    &.item5 {
      background-image: url("../../../common/assets/img/course/bg5.png");
    }

    &.item6 {
      background-image: url("../../../common/assets/img/course/bg6.png");
    }

    &.item7 {
      background-image: url("../../../common/assets/img/course/bg7.jpg");
    }

    &.item8 {
      background-image: url("../../../common/assets/img/course/bg8.jpg");
    }

    &.item9 {
      background-image: url("../../../common/assets/img/course/bg9.jpg");
    }

    &.item10 {
      background-image: url("../../../common/assets/img/course/bg10.jpg");
    }

    &.item11 {
      background-image: url("../../../common/assets/img/course/bg11.jpg");
    }

    &.item12 {
      background-image: url("../../../common/assets/img/course/bg12.jpg");
    }

    &.item13 {
      background-image: url("../../../common/assets/img/course/bg13.jpg");
    }

    &.item14 {
      background-image: url("../../../common/assets/img/course/bg14.jpg");
    }

    &.item15 {
      background-image: url("../../../common/assets/img/course/bg15.jpg");
    }

    &.item16 {
      background-image: url("../../../common/assets/img/course/bg16.jpg");
    }


    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;

    .layer {
      width: 100%;
      cursor: pointer;
      position: relative;

      img {
        width: 100%;
      }

      .description {
        position: absolute;
        bottom: 16px;
        color: white;
        left: 68px;
      }
    }
  }

  @media (min-width: 992px) and (max-width: 1200px) {
    .lobby-theme-home-header-bg {
      height: 370px;
    }
  }

  .lobby-theme-home-menu-bar {

    //调控菜单样式。
    @font-color: #eee;
    @font-highlight: white;
    @menu-bg-color: @main-color;
    @hover-menu-bg-color: #36639B;
    @hover-second-menu-bg-color: #33BEF2;

    background-color: @menu-bg-color;

    .lobby-theme-menu-bar {

      @import "widget/css/MenuBarView";

    }

  }

  //调控footer样式。
  .lobby-theme-footer {
    @font-color: white;
    @import "./widget/css/FooterView";
  }

}
</style>




// WEBPACK FOOTER //
// HomeTheme.vue?d4cb2974